const q = (query) => {
    const parts = Object.entries(query).flatMap(([k, v]) => (v === undefined || v === '' ? [] : [`${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`]));
    return parts.length === 0 ? '' : `?${parts.join('&')}`;
};
export class AdminPlacesApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** The list for the scope and filters (`places:view` at the scope). */
    list(query = {}) {
        return this.client.request({ method: 'GET', path: `/v1/admin/places${q({ ...query })}`, auth: true });
    }
    /** One place with its change history (`places:view` at the place's geography). */
    get(id) {
        return this.client.request({ method: 'GET', path: `/v1/admin/places/${encodeURIComponent(id)}`, auth: true });
    }
    /** Create a manual, verified place (`places:manage`). The same address within the dedup distance updates the existing place (`created: false`). */
    create(input) {
        return this.client.request({ method: 'POST', path: '/v1/admin/places', body: input, auth: true });
    }
    /** Edit a place (`places:manage`); the row becomes verified unless `verified: false` is sent. */
    update(id, patch) {
        return this.client.request({ method: 'PATCH', path: `/v1/admin/places/${encodeURIComponent(id)}`, body: patch, auth: true });
    }
    /** Hide a place: it stays in the base and is never suggested (`places:manage`). */
    hide(id) {
        return this.client.request({ method: 'POST', path: `/v1/admin/places/${encodeURIComponent(id)}/hide`, body: {}, auth: true });
    }
    /** Show a hidden place again (`places:manage`). */
    unhide(id) {
        return this.client.request({ method: 'POST', path: `/v1/admin/places/${encodeURIComponent(id)}/unhide`, body: {}, auth: true });
    }
    /** Delete a place (`places:manage`); its change history stays. */
    remove(id) {
        return this.client.request({ method: 'DELETE', path: `/v1/admin/places/${encodeURIComponent(id)}`, auth: true });
    }
    /** Clear places in bulk (`places:purge` at the geography the clear names); returns how many went. */
    purge(input) {
        return this.client.request({ method: 'POST', path: '/v1/admin/places/purge', body: input, auth: true });
    }
    /** Clear the paid route answers of the geo provider cache - all, or only the expired (`places:purge` at the platform). */
    purgeRouteCache(mode) {
        return this.client.request({ method: 'POST', path: '/v1/admin/places/route-cache/purge', body: { mode }, auth: true });
    }
}
//# sourceMappingURL=admin-places.js.map